import { render, staticRenderFns } from "./MyVideoCourses.vue?vue&type=template&id=519aa46e&scoped=true"
import script from "./MyVideoCourses.vue?vue&type=script&lang=js"
export * from "./MyVideoCourses.vue?vue&type=script&lang=js"
import style0 from "./MyVideoCourses.vue?vue&type=style&index=0&id=519aa46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519aa46e",
  null
  
)

export default component.exports